<template>
	<section
		:class="{
			'bg-brand-globus-green text-body-inverse py-6 sm:py-14' : variant === 'green' || variant === 'orange',
			'bg-gradient-gray text-body-inverse py-6 sm:py-14' : variant === 'dark',
			'bg-background-secondary py-6 sm:py-14' : variant === 'grey',
		}"
		:aria-label="title"
	>
		<div class="container">
			<div v-if="title || subtitle || $slots.top" class="block sm:flex justify-between gap-x-4 items-start mb-4 sm:mb-10">
				<div v-if="title || subtitle" class="flex flex-col gap-y-6 mb-4 lg:mb-0">
					<h2 v-if="title" class="typo-h1 mb-0" v-text="title" />
					<p v-if="subtitle" class="rem:max-w-[820px] hidden sm:block typo-body-l" v-text="subtitle" />
				</div>
				<div v-if="$slots.top">
					<slot name="top" />
				</div>
			</div>

			<div
				v-if="$slots.default"
				:class="listClass"
				class="
					grid
					grid-cols-[var(--grid-cols,repeat(2,minmax(0,1fr)))]
					md:grid-cols-[var(--grid-cols-md,repeat(4,minmax(0,1fr)))]
					gap-4
					sm:gap-16
					md:gap-12
					rem:lg:gap-[85px]
				"
				role="list"
			>
				<slot />
			</div>

			<slot name="bottom" />
		</div>
	</section>
</template>

<script setup lang="ts">
	interface Props {
		title?: string
		subtitle?: string
		variant?: string
		listClass?: string
	}

	defineProps<Props>();
</script>
